import React, { useEffect, useRef, useState } from 'react';
import ImageV2 from 'components_v2/common/ImageV2';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import InViewObserver from 'components/InViewObserver';
import s from './PhotostoryCard.scss';
import { createPhotostoryImageUrl } from '../../utils';
import StlButton from '../STLButton/STLButton';

const PhotostoryCard = props => {
  const {
    data,
    count,
    totalCount,
    isWapView,
    textSize,
    showShopTheLookButton = false,
  } = props;
  const paraCaptionRef = useRef(null);

  const scrollHeightCheck = 120;

  const [readMoreClicked, setReadMoreClicked] = useState(false);
  const [isReadMoreVisible, setIsReadMoreVisible] = useState(false);

  const imageUrl = createPhotostoryImageUrl(data, isWapView);

  const resetReadMore = () => {
    if (paraCaptionRef && paraCaptionRef.current) {
      const contentHeight = paraCaptionRef.current.scrollHeight;
      if (contentHeight >= scrollHeightCheck) {
        setIsReadMoreVisible(true);
      } else {
        setIsReadMoreVisible(false);
      }
    } else {
      setIsReadMoreVisible(true);
    }
  };
  useEffect(() => {
    resetReadMore();
  }, []);

  useEffect(
    () => {
      resetReadMore();
    },
    [textSize],
  );

  return (
    <InViewObserver
    // inViewCallback={() => {
    //   analyticsWrapper('ga4', {
    //     event: 'user_shown',
    //     type: 'photostory_scroll',
    //     label: data.hl,
    //     story_no: count,
    //     msid: data.id,
    //   });
    // }}
    >
      <div className={s.photostoryCard}>
        {showShopTheLookButton && (
          <StlButton index={count} imageMsid={data.id} />
        )}
        <figure
          data-ua-type="1"
          data-sp-pd-click="stpPgtnAndPrvntDefault(event)"
          onClick={event => {
            window.stpPgtnAndPrvntDefault(event);
          }}
        >
          <ImageV2
            key={data.id}
            width="844"
            src={imageUrl}
            placeHolderSrc="https://static.toiimg.com/photo/83033472.cms"
            alt={data.hl}
            altTitle={data.hl}
            lazyload={count > 1}
            // onError={customOnError}
            offsetVertical={200}
            className={s.story_img}
          />
        </figure>
        <div className={s.descriptionArea}>
          <div
            className={s.count}
            data-ua-type="1"
            data-sp-pd-click="stpPgtnAndPrvntDefault(event)"
            onClick={event => {
              window.stpPgtnAndPrvntDefault(event);
            }}
          >
            <strong>{count}</strong>
            <span>/{totalCount}</span>
          </div>
          <h2
            dangerouslySetInnerHTML={{
              __html: `${data.hl}`,
            }}
            data-ua-type="1"
            data-sp-pd-click="stpPgtnAndPrvntDefault(event)"
            onClick={event => {
              window.stpPgtnAndPrvntDefault(event);
            }}
          />
          {data.cap && (
            <div
              className={`${s.paraCaption}  ${
                readMoreClicked ? s.readMoreVisible : ''
              }`}
            >
              <div
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: `${data.cap}`,
                }}
                className={s.text}
                ref={paraCaptionRef}
                data-ua-type="1"
                data-sp-pd-click="stpPgtnAndPrvntDefault(event)"
                onClick={event => {
                  window.stpPgtnAndPrvntDefault(event);
                }}
              />
              {isReadMoreVisible && (
                <span
                  onClick={() => {
                    setReadMoreClicked(!readMoreClicked);
                  }}
                  className={s.readMore}
                >
                  {readMoreClicked ? 'Read Less' : 'Read More'}
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    </InViewObserver>
  );
};

export default PhotostoryCard;
